/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Fragment } from 'react';

import { track } from '@coursera/event-pulse/sdk';

import useEnterpriseMegaMenuLinks, {
  useEnterpriseOrgScopedMenuLinks,
} from 'bundles/composable-page-header-enterprise/hooks/useEnterpriseMegaMenuLinks';
import MobileButton from 'bundles/composable-page-header/components/mobile-menu-items/MobileButton';
import { MOBILE_MAIN_IDENTIFIER } from 'bundles/composable-page-header/constants';
import { useMobileToSubPage } from 'bundles/composable-page-header/contexts/MobileNavigationContext';
import { useIsOrgScopedHome } from 'bundles/unified-common/hooks/useIsOrgScopedHome';

const styles = {
  exploreButton: css`
    margin-top: var(--cds-spacing-100);
  `,
  lastInSection: css`
    padding-top: var(--cds-spacing-100);
    padding-bottom: var(--cds-spacing-100);
  `,
};

const convertIdToMobileId = (id: string) => {
  switch (id) {
    case 'from-program':
      return MOBILE_MAIN_IDENTIFIER.EXPLORE_PROGRAM;
    case 'from-organization':
      return MOBILE_MAIN_IDENTIFIER.EXPLORE_ORGANIZATION;
    case 'skills':
      return MOBILE_MAIN_IDENTIFIER.EXPLORE_SKILLS_MENU;
    case 'categories':
      return MOBILE_MAIN_IDENTIFIER.EXPLORE_CATEGORIES_MENU;
    case 'explore-more-from-coursera':
      return MOBILE_MAIN_IDENTIFIER.EXPLORE_MORE;
    default:
      return MOBILE_MAIN_IDENTIFIER.EXPLORE_PROGRAM;
  }
};

const EnterpriseExploreMenuItem = () => {
  const toSubPage = useMobileToSubPage();

  const isOrgScopedHomeEnabled = useIsOrgScopedHome();
  const orgScopedLinks = useEnterpriseOrgScopedMenuLinks();
  const megaMenuLinks = useEnterpriseMegaMenuLinks();
  const links = isOrgScopedHomeEnabled ? orgScopedLinks : megaMenuLinks;

  return (
    <Fragment>
      {links?.map(({ id, title }, index) => (
        <MobileButton
          key={id}
          css={
            (index === 0 && styles.exploreButton) || (index === links.length - 1 && styles.lastInSection) || undefined
          }
          label={title}
          name={id}
          ariaLabel={title}
          trackingName={id}
          onButtonClick={() => {
            track('view_megamenu_items', {
              megamenuItemName: id,
              megamenuSection: id,
            });
            toSubPage?.(convertIdToMobileId(id));
          }}
        />
      ))}
    </Fragment>
  );
};

export default EnterpriseExploreMenuItem;
